import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page.component';
import { ActionPlanItem, ActionPlanModel } from '../../shared/models/index';
import { ConfirmComponent } from '../../modal/confirm.component';
import { ActionPlanService } from '../../shared/services/index';
import { ActivatedRoute, Router, Params } from '@angular/router';

@Component({
    templateUrl: 'item-detail.component.html',
    standalone: false
})
export class ActionPlanItemDetailPageComponent extends BasePageComponent implements OnInit {
  public actionPlanItem: ActionPlanItem;
  public actionPlan: ActionPlanModel;
  public actionPlanId: string;
  public actionPlanItemId: string;
  public plugins: any[];
  showHelp = false;
  public processing = false;
  loading = false;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private actionPlanService: ActionPlanService
  ) {
    super(location);
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) {
        this.router.navigate([this.actionPlansRoute]);
      }
      this.actionPlanId = id;

      const actionPlanItemId = params['actionPlanItemId'];
      if (actionPlanItemId == null) {
        this.router.navigate([this.actionPlansRoute, this.actionPlanId]);
      }
      this.actionPlanItemId = actionPlanItemId;

      this.actionPlanService.getActionPlan(this.actionPlanId).subscribe((data) => {
        this.actionPlan = data;
      });

      this.actionPlanService.getActionPlanItem(this.actionPlanId, this.actionPlanItemId).subscribe((data) => {
        this.actionPlanItem = data;
      });
    });
  }

  public openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open();
  }

  public selectMenu(item: any) {}

  public updateShowHelp() {
    this.showHelp = !this.showHelp;
    this.modal.cmpRef.instance.updateShowHelpText(!this.showHelp);
  }

  cancel(): void {
    this.goToBack();
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deleteActionPlanItem() {
    this.goToBack();
  }

  updateStatus(e: any) {}

  deletePoint(e: any) {}
}
